export default __webpack_public_path__ + "static/media/filter_white.6b54c356.svg";